import { CarouselRoot, CarouselContainer, CarouselItem } from '../../Carousel.styles'
import useTranslation from 'next-translate/useTranslation'
import { Icon } from 'components/Icon'
import Image from 'next/image'
import { DottedLine, EventDetails, EventTitle, ProgressBar } from './History.styles'
import Ancient from '../../../../../public/assets/illustration-ancient-rome.svg'
import Biscuits from '../../../../../public/assets/illustration-biscuits.svg'
import Steak from '../../../../../public/assets/illustration-steak.svg'
import Rations from '../../../../../public/assets/illustration-rations.svg'
import Horse from '../../../../../public/assets/illustration-horse-meat.svg'
import Kibble from '../../../../../public/assets/illustration-kibble.svg'
import Lobbied from '../../../../../public/assets/illustration-lobbied.svg'
import Dog from '../../../../../public/assets/illustration-exclamation-paw.svg'
import HappyDog from '../../../../../public/assets/illustration-dog-bowl.svg'

export type EventsTypes = {
  title: string
  details: string
  image: string
  breakTitle: boolean
  altText: string
}

export type HistoryTimelineProps = {
  isDesktop: boolean
  currentSlide: number
  setCurrentSlide: (value: number) => void
}

export const HistoryTimeline = ({
  isDesktop,
  currentSlide,
  setCurrentSlide,
}: HistoryTimelineProps) => {
  const { t } = useTranslation()

  const events: EventsTypes[] = [
    {
      title: t('our-story:history.events.event-1.title'),
      details: t('our-story:history.events.event-1.details'),
      image: Ancient,
      breakTitle: true,
      altText: t('our-story:history.events.event-1.altText'),
    },
    {
      title: t('our-story:history.events.event-2.title'),
      details: t('our-story:history.events.event-2.details'),
      image: Biscuits,
      breakTitle: true,
      altText: t('our-story:history.events.event-2.altText'),
    },
    {
      title: t('our-story:history.events.event-3.title'),
      details: t('our-story:history.events.event-3.details'),
      image: Steak,
      breakTitle: true,
      altText: t('our-story:history.events.event-3.altText'),
    },
    {
      title: t('our-story:history.events.event-4.title'),
      details: t('our-story:history.events.event-4.details'),
      image: Horse,
      breakTitle: true,
      altText: t('our-story:history.events.event-4.altText'),
    },
    {
      title: t('our-story:history.events.event-5.title'),
      details: t('our-story:history.events.event-5.details'),
      image: Rations,
      breakTitle: true,
      altText: t('our-story:history.events.event-5.altText'),
    },
    {
      title: t('our-story:history.events.event-6.title'),
      details: t('our-story:history.events.event-6.details'),
      image: Kibble,
      breakTitle: true,
      altText: t('our-story:history.events.event-6.altText'),
    },
    {
      title: t('our-story:history.events.event-7.title'),
      details: t('our-story:history.events.event-7.details'),
      image: Lobbied,
      breakTitle: false,
      altText: t('our-story:history.events.event-7.altText'),
    },
    {
      title: t('our-story:history.events.event-8.title'),
      details: t('our-story:history.events.event-8.details'),
      image: Dog,
      breakTitle: false,
      altText: t('our-story:history.events.event-8.altText'),
    },
    {
      title: t('our-story:history.events.event-9.title'),
      details: t('our-story:history.events.event-9.details'),
      image: HappyDog,
      breakTitle: false,
      altText: t('our-story:history.events.event-9.altText'),
    },
  ]

  const scrollStyle = isDesktop ? 'none' : 'x'

  return (
    <CarouselRoot padding="small">
      {isDesktop && (
        <button
          style={{
            transform: 'translate(-2rem, -4rem)',
            position: 'absolute',
            left: '0',
            zIndex: 1,
          }}
          className="shiftTop arrow"
          onClick={() => setCurrentSlide(currentSlide - 1)}
          disabled={currentSlide == 0}
        >
          <Icon color="accent-black" size="6" name="angle-left" />
        </button>
      )}
      <CarouselContainer style={{ width: '100%' }} scroll={scrollStyle} id="slider-history">
        {events.map((event, index) => (
          <CarouselItem
            scroll="x"
            width="fourth"
            alignItems="start"
            imageRadius="none"
            slide={currentSlide}
            key={index}
            style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column' }}
          >
            <div style={{ height: '130px', width: '150px' }}>
              <Image src={event.image} alt={event.altText} />
            </div>
            <p>
              <EventTitle>{event.title}</EventTitle>
              {event.breakTitle ? <br /> : ' '}
              <EventDetails>{event.details}</EventDetails>
            </p>
          </CarouselItem>
        ))}
      </CarouselContainer>
      {isDesktop && (
        <button
          style={{
            transform: 'translate(2rem, -4rem)',
            position: 'absolute',
            right: '0',
            zIndex: 1,
          }}
          className="shiftTop arrow"
          onClick={() => setCurrentSlide(currentSlide + 1)}
          disabled={
            isDesktop ? currentSlide == events.length - 4 : currentSlide == events.length - 1
          }
        >
          <Icon color="accent-black" size="6" name="angle-right" />
        </button>
      )}
    </CarouselRoot>
  )
}
